"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SectionFourV2 = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var Button_1 = __importDefault(require("../../../../components/Button"));
var styles_1 = require("./styles");
var comp_svg_1 = __importDefault(require("../../../../static/img/productsCS/comp.svg"));
var phone_and_processing_png_1 = __importDefault(require("../../../../static/img/png/phone-and-processing.png"));
var cards_png_1 = __importDefault(require("../../../../static/img/png/cards.png"));
var react_router_dom_1 = require("react-router-dom");
function SectionFourV2() {
    var navigate = (0, react_router_dom_1.useNavigate)();
    var arrayCardsFour = [
        {
            icon: cards_png_1.default,
            title: 'Tarjeta prepagada',
            paragraph: 'Tarjetas corporativas personalizadas, recargables, aceptadas en todos los comercios (físicas o virtuales).',
            action: function () {
                navigate('/prepaid-card');
            }
        },
        {
            icon: phone_and_processing_png_1.default,
            title: 'Billetera electrónica',
            paragraph: 'Aplicación móvil para operaciones financieras sin cuenta bancaria, desde casa y sin filas. Útil para bancos, cooperativas, tiendas y más.',
            action: function () { }
        },
        {
            icon: comp_svg_1.default,
            title: 'Desarrollo de software',
            paragraph: 'Desarrollo personalizado de aplicaciones, incluyendo apps móviles, sitios web, tiendas en línea y más, según las necesidades del cliente.',
            action: function () { }
        },
    ];
    return ((0, jsx_runtime_1.jsxs)(styles_1.ContainerFour, { children: [(0, jsx_runtime_1.jsxs)(styles_1.FourContentWrapper, { children: [(0, jsx_runtime_1.jsxs)(styles_1.FourContentHead, { children: [(0, jsx_runtime_1.jsx)(styles_1.SectionTitle, __assign({ className: "four" }, { children: "Maximiza el \u00E9xito de tu negocio con m\u00E1s soluciones GBC" })), (0, jsx_runtime_1.jsx)("p", { children: "Facilitamos la conexi\u00F3n entre tu negocio y tus clientes a trav\u00E9s de nuestra gama de productos." })] }), (0, jsx_runtime_1.jsx)(styles_1.ServicesWrapper, { children: arrayCardsFour.map(function (card, index) { return ((0, jsx_runtime_1.jsxs)(styles_1.ServiceFeatureCard, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "image-wrapper" }, { children: (0, jsx_runtime_1.jsx)("img", { src: card.icon, alt: card.title }) })), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "content-wrapper" }, { children: [(0, jsx_runtime_1.jsx)("h4", { children: card.title }), (0, jsx_runtime_1.jsx)("p", { children: card.paragraph })] })), (0, jsx_runtime_1.jsx)(Button_1.default, __assign({ variant: 'outline', color: 'cyan', onClick: card.action }, { children: "M\u00E1s info" }))] }, index)); }) })] }), (0, jsx_runtime_1.jsx)(styles_1.LargeCyanImg, {})] }));
}
exports.SectionFourV2 = SectionFourV2;
